"use strict";
var __spreadArray = (this && this.__spreadArray) || function (to, from, pack) {
    if (pack || arguments.length === 2) for (var i = 0, l = from.length, ar; i < l; i++) {
        if (ar || !(i in from)) {
            if (!ar) ar = Array.prototype.slice.call(from, 0, i);
            ar[i] = from[i];
        }
    }
    return to.concat(ar || Array.prototype.slice.call(from));
};
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.DpDetailedPerformanceTable = void 0;
var jsx_runtime_1 = require("react/jsx-runtime");
var react_1 = require("react");
var api_1 = require("../../../api");
var DpDetailedPerformanceTable_styled_1 = require("./DpDetailedPerformanceTable.styled");
var DpDetailedPerformanceHeader_1 = __importDefault(require("./DpDetailedPerformanceHeader"));
var DpStudentDetailedPerformance_1 = __importDefault(require("./DpStudentDetailedPerformance"));
var DpDetailedPerformanceTable = function (_a) {
    var headers = _a.headers, data = _a.data, classId = _a.classId, _b = _a.columnsToShow, columnsToShow = _b === void 0 ? 1 : _b, selectBadgeHandler = _a.selectBadgeHandler, isDiagnostic = _a.isDiagnostic, followUpAssessments = _a.followUpAssessments, supportingData = _a.supportingData, _c = _a.LTIRedirectionFlow, LTIRedirectionFlow = _c === void 0 ? false : _c;
    // ------------------------------- State
    var _d = (0, react_1.useState)(false), initialized = _d[0], setInitialized = _d[1];
    var _e = (0, react_1.useState)([]), sortedData = _e[0], setData = _e[1];
    var _f = (0, react_1.useState)({
        direction: api_1.SortDirectionEnumerables.ascending,
        property: 'name',
    }), sortingCriteria = _f[0], setSortingCriteria = _f[1];
    var sortingCriteriaChanged = (0, react_1.useCallback)(function (criteria) {
        setSortingCriteria(criteria);
        var copyArray = __spreadArray([], data, true);
        var overallRow = copyArray.shift();
        copyArray.sort((0, api_1.sortByCriteria)(criteria));
        copyArray.unshift(overallRow);
        setData(copyArray);
    }, [data]);
    (0, react_1.useEffect)(function () {
        var actives = [];
        setData(data);
        for (var i = 0; i < columnsToShow; i++) {
            actives.push(i);
        }
        if (actives.length === columnsToShow) {
            setInitialized(true);
        }
        // Default Sort by Name;
        sortingCriteriaChanged(sortingCriteria);
    }, [data, columnsToShow, isDiagnostic, sortingCriteriaChanged, sortingCriteria]);
    return (initialized && ((0, jsx_runtime_1.jsx)(DpDetailedPerformanceTable_styled_1.StyledDetailedPerformanceTable, { isDiagnostic: isDiagnostic, horizontalScroll: headers.length > columnsToShow, "data-testid": "dp-detailed-performance-table", children: (0, jsx_runtime_1.jsxs)("table", { className: "report ".concat(headers.length > columnsToShow && 'horizontal-scroll'), children: [(0, jsx_runtime_1.jsx)(DpDetailedPerformanceHeader_1.default, { headers: headers, isDiagnostic: isDiagnostic, sortingCriteria: sortingCriteria, sortingCriteriaChangeHandler: sortingCriteriaChanged }), (0, jsx_runtime_1.jsx)(DpStudentDetailedPerformance_1.default, { data: sortedData, classId: classId, selectBadgeHandler: selectBadgeHandler, isDiagnostic: isDiagnostic, supportingData: supportingData, followUpAssessments: followUpAssessments, LTIRedirectionFlow: LTIRedirectionFlow })] }) })));
};
exports.DpDetailedPerformanceTable = DpDetailedPerformanceTable;
exports.default = exports.DpDetailedPerformanceTable;
